import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { userApi } from "../api/user";
import { HttpStatusCode } from "axios";
import { isTokenExpired } from "../utils/tokenUtils";

const getInitialAuthState = () => {
	const token = localStorage.getItem("yw_mall_token");

	if (!token)
		return { isAuthenticated: false, token: null };

	if (isTokenExpired(token)) {
		localStorage.removeItem("yw_mall_token");
		return { isAuthenticated: false, token: null };
	}

	return { isAuthenticated: true, token };
}

const initialState = getInitialAuthState();

export const loginUser = createAsyncThunk(
	'user/login',
	async (loginData, { rejectWithValue }) => {
		try {
			const response = await userApi.getUsers(loginData);
			
			if (response.accessToken) {
				localStorage.setItem("yw_mall_token", response.accessToken);
			}
			return response;
		} catch (error) {
			if(error.response && error.response.status === HttpStatusCode.NotFound) {
				alert("입력하신 아이디로 가입된 계정이 없습니다.");
				return rejectWithValue("Not Found ID.");
			}

			if(error.response && error.response.status === HttpStatusCode.Unauthorized) {
				alert("비밀번호가 일치하지 않습니다.");
				return rejectWithValue("Invalid password.");
			}

			alert("로그인 중 오류가 발생했습니다. 다시 시도해주세요.");
			return rejectWithValue(error.message);
		}
	}
);

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		reset: (state) => {
			state.isAuthenticated = false;
			state.token = null;
			localStorage.removeItem("yw_mall_token");
		},
		setToken: (state, action) => {
			state.token = action.payload;
			state.isAuthenticated = true;
			localStorage.setItem("yw_mall_token", action.payload);
		}
	},
	extraReducers: (builder) => {
		builder
		// 로그인
			.addCase(loginUser.fulfilled, (state, action) => {
				state.isAuthenticated = true;
				state.token = action.payload.accessToken;
			})
			.addCase(loginUser.rejected, (state, action) => {
				console.error("Login failed:", action.payload);
			});
	}
});

export const { reset, setToken } = userSlice.actions;

export default userSlice.reducer;